module.exports = __webpack_public_path__ + "static/media/pricingB.a0443d6c.png";